import type { ApplicationType } from 'commons/constants';
import { createContext } from 'react';

export const CreditCardApplicationContext = createContext<{
  creditCardApplication: ApplicationType;
  fetchCreditCardApplication: Function;
  fetchAndResumeCreditCardApplication: Function;
  fetchingApplication: boolean;
  showApplicationFetchError: boolean;
  showVerificationWaitingRoom: boolean;
  setShowVerificationWaitingRoom: Function;
  pollCreditCardApplication: Function;
  pollingApplication: boolean;
  showPollingError: boolean;
  onSuperscriptClick: Function;
  onSuperscriptEnter: Function;
} | null>({
  creditCardApplication: null,
  fetchCreditCardApplication: null,
  fetchAndResumeCreditCardApplication: null,
  fetchingApplication: null,
  showApplicationFetchError: null,
  showVerificationWaitingRoom: null,
  setShowVerificationWaitingRoom: null,
  pollCreditCardApplication: null,
  pollingApplication: false,
  showPollingError: false,
  onSuperscriptClick: null,
  onSuperscriptEnter: null,
});
